import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { close as closeSign } from 'assets/icons';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { actions } from 'core/redux/api/veta/tep/entry-passes';
import { ModalWrapper } from 'components/molecules/modal-wrapper';
import { entryPassesErrorSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

export const ErrorModal: FC = () => {
  const dispatch = useDispatch();

  const error = useSelector(entryPassesErrorSelector);

  const close = () => dispatch(actions.clear());

  return error ? (
    <ModalWrapper>
      <div className={styles.content}>
        <span className={styles.close} onClick={close}>
          <SvgWrapper width={26} height={26} details={closeSign} />
        </span>
        <div className={styles.error}>{error}</div>
      </div>
    </ModalWrapper>
  ) : null;
};
